exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".download-container{position:absolute;right:0;top:10px;width:200px;height:150px;z-index:99;border:1px solid transparent;padding:2px;font-size:10pt;display:flex;flex-direction:column;justify-content:space-between}.download-container.closed{width:38px}.download-container.open{border:1px solid gray;background:#fff}.download-container a,.download-container button{display:inline-block;min-height:30px;background-color:#cacaca;background-repeat:no-repeat;background-position:center;margin:2px;color:#fff;font-weight:700}.download-container a{padding:8px}.download-container button.openClose{min-width:38px;align-self:flex-end;background-image:url(" + require("../image/download.png") + ")}.download-container .format{margin-bottom:10px}.download-container button:hover,.download-container.open a,.download-container.open button{background-color:#2888a5}.download-container .formats,.download-container .message{align-self:center}.download-container.closed .format,.download-container.closed .message{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/download.css
// module id = 100
// module chunks = 0